// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue'
import room from './components/room.vue'
import eventBus from './util/eventBus'

/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
(function (KDApi) {
  function MyComponent(model) {
    this._setModel(model)
  }

  MyComponent.prototype = {
    _setModel: function (model) {
      this.model = model
    },
    init: function (props) {
      console.log('-----init222', this.model, props)
      setHtml(this.model, props)
    },
    update: function (props) {
      console.log('-----update', this.model, props)
      eventBus.pub(this.model, 'update', props)
    },
    destoryed: function () {
      console.log('-----destoryed', this.model)
    }
  }

  const setHtml = (model, props) => {

    KDApi.loadFile('./css/index.css', model, () => {
      const { invoke, dom } = model
      const { data } = props
      const activeI = data ? data.avtiveIndex : -1
      new Vue({
        el: dom,
        template: '<room :invoke="invoke" :buildBeanList="buildBeanList" :unitHoldBean="unitHoldBean" :type="type" :roomBean="roomBean" :indexList="indexList" :roomBeanList="roomBeanList" :themeColor="themeColor" :model="model" :getLangMsg="getLangMsg" :saleStatusBeanList="saleStatusBeanList"/>',
        components: {
          room
        },
        data: {
          activeIndex: activeI,
          model: model,
          buildBeanList:[],
          saleStatusBeanList:[],
          themeColor:'',
          indexList:[],
          roomBean:{},
          roomBeanList:[],
          unitHoldBean:{},
          type:''
        },
        mounted() {
          const self = this
          this.updateSub = eventBus.sub(model, 'update', (props) => {
            this.themeColor=props.themeNum
            if(props.data.type=='exit'){
                return
            }
            console.log('props',props)
            const { data } = props
            if(data.type=='init_data'||data.type=='insert_unithold'||data.type=='insert_floor'||data.type=='delete_unithold'||data.type=='delete_floor'){
              self.saleStatusBeanList = data ? data.saleStatusBeanList : []
              self.buildBeanList = data ? data.buildBeanList : []
              if( self.buildBeanList != undefined ||  self.buildBeanList.length > 0){
                self.buildBeanList.forEach((i)=>{
                  if( i.buildHeadBean.unitBeanList != undefined || i.buildHeadBean.unitBeanList.length > 0){
                  i.buildHeadBean.unitBeanList.forEach((ii)=>{

                    if(ii.unitHoldBeanList.length==1&&ii.name.length>3&&ii.name.length<=6)
                    {
                      self.$set(ii,'isMore',1)
                    }else if(ii.unitHoldBeanList.length==1&&ii.name.length>6){
                      self.$set(ii,'isMore',2)
                    }else{
                      self.$set(ii,'isMore',0)
                    }
                  })
                  }
                  if( i.floorBeanList != undefined || i.floorBeanList.length > 0){
                        i.floorBeanList.forEach((ii)=>{
                          if( ii.unitBeanList != undefined ||  ii.unitBeanList.length > 0){
                            ii.unitBeanList.forEach((iii)=>{

                              if(iii.roomBeanList.length==1&&iii.name.length>3&&iii.name.length<=6&&(iii.roomBeanList[0].roomSize==0||iii.roomBeanList[0].roomSize==1))
                                {
                                  self.$set(iii,'isMore',1)
                                }else if(iii.roomBeanList.length==1&&iii.name.length>6&&(iii.roomBeanList[0].roomSize==0||iii.roomBeanList[0].roomSize==1)){
                                  self.$set(iii,'isMore',2)
                                }else{
                                  self.$set(iii,'isMore',0)
                                }
                              iii.roomBeanList.forEach((iiii)=>{
                                self.$set(iiii,'isSelect',false)
                              })
                              self.$set(iii,'isMousedownPro',false)
                              self.$set(iii,'isMouseupPro',false)
                              // isMousedownPro

                            })
                          }
                        })
                  }
                })
              }
              console.log('buildBeanList',self.buildBeanList)
            }
            if(data.type=='new_room'||data.type=='edit_room'||data.type=='delete_room'){
              console.log('操作房间2')
              self.saleStatusBeanList = data ? data.saleStatusBeanList : []
              self.roomBean = data ? data.roomBean : {}
              self.indexList = data ? data.indexList : []
              self.type=data ? data.type :''
              self.unitHoldBean=data ? data.unitHoldBean :{}

            }
            if(data.type=='split_room'||data.type=='merge_rooms'){
              console.log('操作房间2')
              self.saleStatusBeanList = data ? data.saleStatusBeanList : []
              self.roomBeanList = data ? data.roomBeanList : {}
              self.indexList = data ? data.indexList : []
            }
          })
        },
        destroyed() {
          eventBus.unsub(this.updateSub)
        },
        methods: {
          invoke: (eventName, args) => {
            invoke(eventName, args)
          },
          getLangMsg: (key) => {
            return KDApi.getLangMsg(model, key)
          }
        }
      })
    })
  }

  // 注册自定义组件
  KDApi.register('resbdadjustsourcehouse', MyComponent, {
    isMulLang: true
  })
})(window.KDApi)
